import { createAction, props } from '@ngrx/store';
import { DemandNoticeInvoiceReducerStateInterface } from '../reducers/demand-notice-invoice.reducer';

const prefix = '[Demand-Notice-Invoice]';

export const setStateAction = createAction(
  `${prefix} set state`,
  props<Partial<DemandNoticeInvoiceReducerStateInterface>>()
);

export const resetStateAction = createAction(
  `${prefix} reset query`,
  props<Partial<DemandNoticeInvoiceReducerStateInterface>>()
);
